import React, { useState } from 'react';

// const accordionData = [
//   {
//     title: "EVENT INFORMATION",
//     content: [
//       { 
//         question: "When & where is the event taking place?", 
//         answer: "Bandland will take place on February 14th and 15th, 2026, at Nice Grounds, BIEC, Madavara, Bengaluru." 
//       },
//       { 
//         question: "What are the festival timings?", 
//         answer: "The festival will run for 8 hours on each day. Exact timing and detailed schedule will be announced closer to the festival date." 
//       },
//       { 
//         question: "Is there a map for the festival?", 
//         answer: "The venue layout and festival map will be posted soon. Watch this space or stay in the loop via our social media handles (Instagram: @bandland.in)." 
//       },
//       { 
//         question: "How do I contact the festival?", 
//         answer: `Email us <a href="mailto:bandland.help@bookmyshow.com">here</a> for general/ticketing queries.<br/>
//                  Email us <a href="mailto:sponsorship@bookmyshow.com">here</a> for sponsorship inquiries.<br/>
//                  Email us <a href="mailto:media@bookmyshow.com">here</a> for press & editorial inquiries.<br/>
//                  Email us <a href="mailto:corpsales@bookmyshow.com">here</a> for corporate sales.` 
//       },
//       { 
//         question: "When will the line-up come out? Is there a day-wise schedule of performances?", 
//         answer: "The Bandland 2026 line-up and day-wise schedule will be posted on Bandland’s socials soon - Stay tuned!" 
//       }
//     ]
//   },
//   {
//     title: "TICKET INFORMATION",
//     content: [
//       {
//         question: "What ticketing categories are available at Bandland 2026?",
//         answer: "Patrons can avail of tickets in The Citizen (GA), RuPay Credit Rock & Roller (VIP), and Ace of Spades (Platinum) ticketing categories."
//       },
//       {
//         question: "Is there a Presale? How can I avail it?",
//         answer: `The RuPay Presale will be open from Oct 15, 12 PM to Oct 17, 12 PM, 2025. Only RuPay credit card holders can purchase tickets during this presale. Don’t have a RuPay credit card? <a href="https://www.rupay.co.in/" target="_blank">Click here</a> to know more on how you can get one in time for the presale!`
//       },
//       {
//         question: "When does General Sale begin?",
//         answer: "General sale goes live on Oct 17, 2025 at 1 PM."
//       },
//       {
//         question: "Is there a ticket purchasing limit?",
//         answer: "You can buy up to 10 tickets per person. All ticket categories are subject to availability - so get yours before they sell out!"
//       },
//       {
//         question: "Will I be able to switch my ticket to a different category?",
//         answer: "Unfortunately, tickets cannot be upgraded/switched, exchanged or refunded."
//       },
//       {
//         question: "Will the tickets be available for sale on any other platform?",
//         answer: "No, BookMyShow is the exclusive ticketing partner for the event. We strongly recommend you not to purchase via any third party to avoid counterfeit tickets. Counterfeit tickets won’t enable entry to the festival."
//       },
//       {
//         question: "How can I purchase tickets as an international customer?",
//         answer: "International consumers will get a Box Office pick-up option while transacting. Wristbands can be collected at the Box Office on the day of the event."
//       },
//       {
//         question: "Can I bring my child to the festival? Is there an age limit for ticket purchases?",
//         answer: "The age restriction for this event is 5+. Kids aged 5+ (born before Feb 13, 2021) need to buy a valid ticket that matches the accompanying parent/guardian’s ticket category. All kids aged 16 and below must be accompanied by a parent/guardian."
//       },
//       {
//         question: "Is there an all-area-access ticket with an artist meet & greet?",
//         answer: "There are no all-area-access passes or meet & greets available. Perks & privileges are mentioned in the ticket descriptions."
//       },
//       {
//         question: "I can’t find my Bandland 2026 booking!",
//         answer: `After completing your transaction, your booking details will be emailed to you and listed under “Your Orders” on BookMyShow. If you still can’t find it, please write <a href="mailto:bandland.help@bookmyshow.com">here</a>.`
//       },
//       {
//         question: "When will I get my tickets?",
//         answer: "Your ticket will be a wristband with a unique RFID code on it. These will be delivered approximately within a week before the event."
//       },
//       {
//         question: "How do I get a refund if I can’t make it?",
//         answer: "Tickets are unfortunately not transferable or cancellable."
//       },
//       {
//         question: "Am I allowed to enter the festival grounds multiple times?",
//         answer: "Entry is permitted only once per day. Once you exit, re-entry is not allowed."
//       },
//       {
//         question: "Wristband Policy",
//         answer: `Please do not misplace/forget your wristband as replacements will not be provided. Wristbands are NON-TRANSFERABLE and NON-EXCHANGEABLE. Do NOT remove between days, stretch or tamper with it in any way. Wristbands MUST be worn securely on the wrist at all times during the festival.`
//       },
//       {
//         question: "I haven’t received my wristband yet. How will I receive them?",
//         answer: `Wristbands will be home delivered closer to the event. If purchased later, you may have to pick them up from the Box Office on Feb 14–15. If you receive damaged wristbands, please write <a href="mailto:bandland.help@bookmyshow.com">here</a>. ONLY wristbands will be accepted for entry.`
//       },
//       {
//         question: "What are the uses of my wristband?",
//         answer: "Your wristband gives you entry to the festival and acts as the sole payment mode at the venue."
//       },
//       {
//         question: "Can I top up my wristband in advance?",
//         answer: "Yes! Scan the QR code on your wristband, enter your details, and top up using the portal."
//       },
//       {
//         question: "What happens if the event is cancelled?",
//         answer: "You’ll be notified via email & phone, with an option to claim a refund or carry it forward for a future date. Note that convenience & delivery fees are non-refundable."
//       }
//     ]
//   },
//   {
//     title: "HOW TO GET TO THE FESTIVAL",
//     content: [
//       {
//         question: "How do I get to the venue?",
//         answer: `By Road: Use the festival map pin point.<br/>
//                  By Bus: Madavar Bus Stop - 100 M from the venue.<br/>
//                  By Metro: Madavara Station - 50 M from the venue.<br/>
//                  By Train: Yeshwantpur Railway Station - 12 KM away.<br/>
//                  Airport: Kempegowda International Airport - 1 hour drive.`
//       },
//       {
//         question: "Is there parking available at the venue?",
//         answer: `The Citizen: Limited paid parking (first-come-first-serve).<br/>
//                  RuPay Credit Rock & Roller: Limited reserved parking.<br/>
//                  Ace Of Spades: Guaranteed reserved parking.`
//       }
//     ]
//   },
//   {
//     title: "GENERAL INFORMATION",
//     content: [
//       {
//         question: "Is photography permitted during the show?",
//         answer: "Phone cameras are allowed. Professional cameras & videography are not permitted."
//       },
//       {
//         question: "Is the venue air-conditioned?",
//         answer: "No, this is an open-air concert festival."
//       },
//       {
//         question: "Is this a seated show?",
//         answer: "No, this will be a walk-in standing concert. Limited seating will be available in the Ace of Spades lounge."
//       },
//       {
//         question: "Will there be F&B available at the venue?",
//         answer: "Yes, food and beverages will be available for purchase. Outside food or drinks are not permitted."
//       },
//       {
//         question: "Will there be drinking water available at the festival?",
//         answer: "Free drinking water will be available. Bring your own empty, reusable transparent plastic bottle (up to 500ML)."
//       },
//       {
//         question: "Is smoking allowed at the show?",
//         answer: "Only in designated areas. Please dispose of cigarette waste responsibly."
//       },
//       {
//         question: "Are pets allowed at the festival?",
//         answer: "Unfortunately, pets are not allowed at the festival."
//       },
//       {
//         question: "Does the festival have any merchandise?",
//         answer: "Yes! Official festival merch will be revealed closer to the event. Follow Bandland’s socials for updates."
//       },
//       {
//         question: "Where is the Lost & Found at the Festival?",
//         answer: `Visit the nearest Help Desk for lost items or write to <a href="mailto:bandland.help@bookmyshow.com">bandland.help@bookmyshow.com</a>.`
//       }
//     ]
//   },
//   {
//     title: "ACCESSIBILITY + HEALTH, SAFETY & SECURITY",
//     content: [
//       {
//         question: "Is the festival wheelchair friendly? Does the festival provide wheelchairs?",
//         answer: `Yes, the festival is wheelchair-friendly. However, we do not provide wheelchairs. For queries, <a href="mailto:bandland.help@bookmyshow.com">write to us</a>.`
//       },
//       {
//         question: "What medical assistance will be available at the event?",
//         answer: "First aid services will be available throughout the festival. If you have specific health conditions, consult your doctor before attending."
//       },
//       {
//         question: "What safety measures are in place for the festival?",
//         answer: "The festival works with local authorities and trained security teams to ensure a safe experience for all attendees."
//       },
//       {
//         question: "What safety measures are in place for children attending the festival?",
//         answer: "Parents/Guardians should collect a ‘Tag Your Child’ wristband from the Info Desk to help prevent separation incidents."
//       },
//       {
//         question: "Our Policy",
//         answer: "Zero tolerance for hate, harassment, or discrimination of any kind. The festival promotes a safe, inclusive, and drug-free environment."
//       }
//     ]
//   },
//   {
//     title: "ALLOWED & PROHIBITED ITEMS",
//     content: [
//       {
//         question: "What items are allowed/prohibited at the festival?",
//         answer: `Here’s the complete list of allowed/prohibited items: <a href="https://drive.google.com/file/d/1EWc8kAELjLABeMQZ62a71-1yS6wMlmQm/view?usp=drive_link" target="_blank">Click here</a>.`
//       },
//       {
//         question: "Are handbags and backpacks allowed into the venue?",
//         answer: "Bags smaller than A4 size (30cm x 18cm) are allowed but will be scanned. Wallets/clutches up to 6” x 9” will be frisked manually."
//       },
//       {
//         question: "Do you have lockers for rent?",
//         answer: "There will be no lockers at the event."
//       }
//     ]
//   }
// ];

const accordionData = [
  {
    title: "EVENT INFORMATION",
    content: [
      { 
        question: "When & where is the event taking place?", 
        answer: "Bandland will take place on February 14th and 15th, 2026, at Nice Grounds, BIEC, Madavara, Bengaluru." 
      },
      { 
        question: "What are the festival timings?", 
        answer: "The festival will run for 8 hours on each day. Exact timing and detailed schedule will be announced closer to the festival date." 
      },
      { 
        question: "Is there a map for the festival?", 
        answer: "The venue layout and festival map will be posted soon. Watch this space or stay in the loop via our social media handles (Instagram: @bandland.in)." 
      },
      { 
        question: "How do I contact the festival?", 
        answer: `Email us <a href="mailto:bandland.help@bookmyshow.com">here</a> for general/ticketing queries.<br/>
                 Email us <a href="mailto:sponsorship@bookmyshow.com">here</a> for sponsorship inquiries.<br/>
                 Email us <a href="mailto:media@bookmyshow.com">here</a> for press & editorial inquiries.<br/>
                 Email us <a href="mailto:corpsales@bookmyshow.com">here</a> for corporate sales.` 
      },
      { 
        question: "When will the line-up come out? Is there a day-wise schedule of performances?", 
        answer: "The Bandland 2026 line-up and day-wise schedule will be posted on Bandland's socials soon - Stay tuned!" 
      }
    ]
  },
  {
    title: "TICKET INFORMATION",
    content: [
      {
        question: "What ticketing categories are available at Bandland 2026?",
        answer: "Patrons can avail of tickets in The Citizen (GA),Rupay Rock & Roller (VIP), and Ace of Spades (Platinum) ticketing categories."
      },
      {
        question: "Is there a Presale? How can I avail it?",
        answer: `The RuPay Presale will be open from Oct 15, 12 PM to Oct 17, 12 PM, 2025. Only RuPay credit card holders can purchase tickets during this presale. Don't have a RuPay credit card? <a href="https://www.rupay.co.in/" target="_blank">Click here</a> to know more on how you can get one in time for the presale!`
      },
      {
        question: "When does General Sale begin?",
        answer: "General sale goes live on Oct 17, 2025 at 1 PM."
      },
      {
        question: "Is there a ticket purchasing limit?",
        answer: "You can buy up to 10 tickets per person. All ticket categories are subject to availability - so get yours before they sell out!"
      },
      {
        question: "Will I be able to switch my ticket to a different category?",
        answer: "Unfortunately, tickets cannot be upgraded/switched, exchanged or refunded."
      },
      {
        question: "Will the tickets be available for sale on any other platform?",
        answer: "No, BookMyShow is the exclusive ticketing partner for the event. We strongly recommend you not to purchase via any third party to avoid counterfeit tickets. Counterfeit tickets won't enable entry to the festival."
      },
      {
        question: "How can I purchase tickets as an international customer?",
        answer: "International consumers will get a Box Office pick-up option while transacting. Wristbands can be collected at the Box Office on the day of the event."
      },
      {
        question: "Can I bring my child to the festival? Is there an age limit for ticket purchases?",
        answer: "The age restriction for this event is 5+. Kids aged 5+ (born before Feb 13, 2021) need to buy a valid ticket that matches the accompanying parent/guardian's ticket category. All kids aged 16 and below must be accompanied by a parent/guardian."
      },
      {
        question: "Is there an all-area-access ticket with an artist meet & greet?",
        answer: "There are no all-area-access passes or meet & greets available. Perks & privileges are mentioned in the ticket descriptions."
      },
      {
        question: "I can't find my Bandland 2026 booking!",
        answer: `After completing your transaction, your booking details will be emailed to you and listed under "Your Orders" on BookMyShow. If you still can't find it, please write <a href="mailto:bandland.help@bookmyshow.com">here</a>.`
      },
      {
        question: "When will I get my tickets?",
        answer: "Your ticket will be a wristband with a unique RFID code on it. These will be delivered approximately within a week before the event."
      },
      {
        question: "How do I get a refund if I can't make it?",
        answer: "Tickets are unfortunately not transferable or cancellable."
      },
      {
        question: "Am I allowed to enter the festival grounds multiple times?",
        answer: "Entry is permitted only once per day. Once you exit, re-entry is not allowed."
      },
      {
        question: "Wristband Policy",
        answer: `Please do not misplace/forget your wristband as replacements will not be provided. Wristbands are NON-TRANSFERABLE and NON-EXCHANGEABLE. Do NOT remove between days, stretch or tamper with it in any way. Wristbands MUST be worn securely on the wrist at all times during the festival.`
      },
      {
        question: "I haven't received my wristband yet. How will I receive them?",
        answer: `Wristbands will be home delivered closer to the event. If purchased later, you may have to pick them up from the Box Office on Feb 14–15. If you receive damaged wristbands, please write <a href="mailto:bandland.help@bookmyshow.com">here</a>. ONLY wristbands will be accepted for entry.`
      },
      {
        question: "What are the uses of my wristband?",
        answer: "Your wristband gives you entry to the festival and acts as the sole payment mode at the venue."
      },
      {
        question: "Can I top up my wristband in advance?",
        answer: "Yes! Scan the QR code on your wristband, enter your details, and top up using the portal."
      },
      {
        question: "What happens if the event is cancelled?",
        answer: "You'll be notified via email & phone, with an option to claim a refund or carry it forward for a future date. Note that convenience & delivery fees are non-refundable."
      }
    ]
  },
  {
    title: "HOW TO GET TO THE FESTIVAL",
    content: [
      {
        question: "How do I get to the venue?",
        answer: `By Road: Use the festival map pin point.<br/>
                 By Bus: Madavar Bus Stop - 100 M from the venue.<br/>
                 By Metro: Madavara Station - 50 M from the venue.<br/>
                 By Train: Yeshwantpur Railway Station - 12 KM away.<br/>
                 Airport: Kempegowda International Airport - 1 hour drive.`
      },
      {
        question: "Is there parking available at the venue?",
        answer: `The Citizen: Limited paid parking (first-come-first-serve).<br/>
                 Rupay Rock & Roller: Limited reserved parking.<br/>
                 Ace Of Spades: Guaranteed reserved parking.`
      }
    ]
  },
  {
    title: "GENERAL INFORMATION",
    content: [
      {
        question: "Is photography permitted during the show?",
        answer: "Phone cameras are allowed. Professional cameras & videography are not permitted."
      },
      {
        question: "Is the venue air-conditioned?",
        answer: "No, this is an open-air concert festival."
      },
      {
        question: "Is this a seated show?",
        answer: "No, this will be a walk-in standing concert. Limited seating will be available in the Ace of Spades lounge."
      },
      {
        question: "Will there be F&B available at the venue?",
        answer: "Yes, food and beverages will be available for purchase. Outside food or drinks are not permitted."
      },
      {
        question: "Will there be drinking water available at the festival?",
        answer: "Free drinking water will be available. Bring your own empty, reusable transparent plastic bottle (up to 500ML)."
      },
      {
        question: "Is smoking allowed at the show?",
        answer: "Only in designated areas. Please dispose of cigarette waste responsibly."
      },
      {
        question: "Are pets allowed at the festival?",
        answer: "Unfortunately, pets are not allowed at the festival."
      },
      {
        question: "Does the festival have any merchandise?",
        answer: "Yes! Official festival merch will be revealed closer to the event. Follow Bandland's socials for updates."
      },
      {
        question: "Where is the Lost & Found at the Festival?",
        answer: `Visit the nearest Help Desk for lost items or write to <a href="mailto:bandland.help@bookmyshow.com">bandland.help@bookmyshow.com</a>.`
      }
    ]
  },
  {
    title: "ACCESSIBILITY + HEALTH, SAFETY & SECURITY",
    content: [
      {
        question: "Is the festival wheelchair friendly? Does the festival provide wheelchairs?",
        answer: `Yes, the festival is wheelchair-friendly. However, we do not provide wheelchairs. For queries, <a href="mailto:bandland.help@bookmyshow.com">write to us</a>.`
      },
      {
        question: "What medical assistance will be available at the event?",
        answer: "First aid services will be available throughout the festival. If you have specific health conditions, consult your doctor before attending."
      },
      {
        question: "What safety measures are in place for the festival?",
        answer: "The festival works with local authorities and trained security teams to ensure a safe experience for all attendees."
      },
      {
        question: "What safety measures are in place for children attending the festival?",
        answer: "Parents/Guardians should collect a 'Tag Your Child' wristband from the Info Desk to help prevent separation incidents."
      },
      {
        question: "Safety Tips",
        answer: `• Use the buddy system and set up a designated meeting spot if you get lost. We recommend the festival Help Desk.<br/>
                 • Have your emergency contact information on your person and your phone lock screen in case of emergencies.<br/>
                 • Keep yourself and your belongings safe – be aware of your surroundings and keep an eye on your personal items at all times.<br/>
                 • Be considerate – this is a shared space and we want everyone to enjoy themselves.<br/>
                 • See something? Say something - head to the Help Desk for help or to report any mishaps that occur.`
      },
      {
        question: "Our Policy",
        answer: "Zero tolerance towards any unruly behavior or hate based on gender, sexual orientation, race, caste, disability, religion. We strive to keep our festival safe and inclusive. <br/> Zero tolerance towards sexual harassment. <br/> Zero tolerance towards drugs & illegal substances. <br/>"
      }
    ]
  },
  {
    title: "ALLOWED & PROHIBITED ITEMS",
    content: [
      {
        question: "What items are allowed/prohibited at the festival?",
        answer: `Here's the complete list of allowed/prohibited items: <a href="https://drive.google.com/file/d/1ay-C5yD_mvr5M9Lob19uWbc5rHPd8DB2/view?usp=sharing" target="_blank">Click here</a>.`
      },
      {
        question: "Are handbags and backpacks allowed into the venue?",
        answer: "Bags smaller than A4 size (30cm x 18cm) are allowed but will be scanned. Wallets/clutches up to 6\" x 9\" will be frisked manually."
      },
      {
        question: "Do you have lockers for rent?",
        answer: "There will be no lockers at the event."
      }
    ]
  }
];


// function AccordionSection({ section, isOpen, onToggle }) {
//   return (
//     <div className="mb-3">
//       <button
//         onClick={onToggle}
//         style={{
//          boxShadow: "0 13px 0px 0px #00FFFF"
//         }}
//         className="w-full flex z-index-40 justify-between items-center px-5 py-4 bg-black border-2 border-cyan-400 rounded-lg text-white hover:bg-gray-900 transition-colors "
//       >
//         <span className="text-sm md:text-base font-bold tracking-wide">{section.title}</span>
//         <span className="text-cyan-400 text-2xl font-light">
//           {isOpen ? "−" : "+"}
//         </span>
//       </button>
      
//       {isOpen && section.content.length > 0 && (
//         <div className="mt-3 px-5 py-4 bg-black border-2 border-cyan-400 rounded-lg rounded-t-none border-t-0 ">
//           {section.content.map((item, idx) => (
//             <div key={idx} className="mb-6 last:mb-0">
//               <h4 className="text-white text-sm md:text-base font-semibold mb-2">
//                 • {item.question}
//               </h4>
//               <p className="text-gray-300 text-xs md:text-sm pl-4 leading-relaxed" dangerouslySetInnerHTML={{ __html: item.answer }}>
//                 {/* {item.answer} */}
//               </p>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

function AccordionSection({ section, isOpen, onToggle }) {
  return (
    <div className="mb-6">
      <button
        onClick={onToggle}
        style={{
          boxShadow: "0 13px 0px 0px #00FFFF",
          transform: isOpen ? "translateY(10px)" : "translateY(0)",
          transition: "all 0.2s ease"
        }}
        className="w-full flex justify-between items-center px-5 py-4 bg-black border-2 border-cyan-400 rounded-lg text-white hover:bg-gray-900 active:translate-y-2"
      >
        <span className="text-sm md:text-base font-bold tracking-wide">{section.title}</span>
        <span className="text-white text-2xl font-light">
          {isOpen ? "−" : "+"}
        </span>
      </button>
      
      {isOpen && section.content.length > 0 && (
        <div className="px-5 py-4 pt-11 bg-black border-2 border-cyan-400 border-t-0 rounded-b-lg">
          {section.content.map((item, idx) => (
            <div key={idx} className="mb-4 last:mb-0">
              <h4 className="text-white text-sm md:text-base font-semibold mb-2">
                • {item.question}
              </h4>
              <p className="text-gray-300 text-xs md:text-sm pl-4 leading-relaxed" dangerouslySetInnerHTML={{ __html: item.answer }} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
export default function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div style={
      {
        fontFamily: 'Poppins, sans-serif'
      }
    } className="min-h-screen bg-black text-white">
     <style>
  {`
    a {
      text-decoration: underline;

    }
  `}
</style>
      <main className="px-[20px] bg-[#440A06]">
        <div className="text-start relative">
          <div 
            style={{
              backgroundImage: "url('/Group (1).png')",
              backgroundRepeat:"repeat-y",
              backgroundSize: "contain"
            }} 
            className='w-full bg-cover flex flex-col items-center bg-black border-[3px] md:border-[7px] border-white rounded-[15px] lg:rounded-[44px]'
          >
            <img src='/curve left.png' alt='Planet 3' className='absolute left-[2px] md:left-[5px] top-[30px] md:top-[50px] w-[33px] md:w-[100px]' />
            <img src='/curve right.png' alt='Planet 2' className='absolute right-[2px] md:right-[5px] top-[30px] md:top-[50px] w-[33px] md:w-[100px]' />
            
            <img 
              src='/faqlogo.png' 
              alt='Bandland Logo' 
              className='mt-[30px] w-[15%] mb-8' 
            />
            
            <div className="w-[80%] md:w-[70%] max-w-4xl mx-auto px-4 flex flex-col  gap-[10px] md:gap-[20px]">
              {accordionData.map((section, idx) => (
                <AccordionSection
                  key={idx}
                  section={section}
                  isOpen={openIndex === idx}
                  onToggle={() => toggle(idx)}
                />
              ))}
            </div>
            
            <img 
              src='/Screenshot 2025-10-08 132457.png' 
              alt='Event Details' 
              className='mt-16 w-[88%] mb-[15px] sm:mb-[0px]' 
            />
          </div>
        </div>
      </main>
    </div>
  );
}